import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {switchTab} from 'router'
import store from 'store'
import cx from 'classnames'
import {hasAdminPermission} from 'util/admin-permissions'

const GROUPS = [
  {
    label: '日常入口',
    hint: '快速进入后台核心工作',
    items: [
      {text: '运营工作台', url: '/', badge: '总览', icon: '01', permission: 'dashboard.read'}
    ]
  },
  {
    label: '内容运营',
    hint: '小程序展示内容',
    items: [
      {text: '首页音频', url: '/material/home', badge: '音频', icon: '02', permission: 'content.manage'},
      {text: '常见问题', url: '/material/faq', badge: 'FAQ', icon: '03', permission: 'content.manage'}
    ]
  },
  {
    label: '投放工具',
    hint: '批量制作录音卡',
    items: [
      {text: '录音卡生产', url: '/tools/card-batch', badge: '批量', icon: '04', permission: 'card.manage'},
      {text: '音频与音信卡', url: '/tools/card-assets', badge: '链接', icon: '05', permission: 'card.read'}
    ]
  }
]

function userGroup(user) {
  let items = []
  if (user && user.isSuperAdmin) {
    items.push({text: '管理员审批', url: '/users/admin', badge: '审批', icon: '05'})
  }
  if (hasPermission(user, 'user.read')) {
    items.push({text: '全部用户', url: '/users', badge: '用户', icon: '06'})
  }
  return {
    label: '用户权限',
    hint: '账号与后台权限',
    items
  }
}

function hasPermission(user, permission) {
  return hasAdminPermission(user, permission)
}

const Navigator = observer(props => {
  let {url, text, badge, icon} = props
  let currUrl = store.page ? store.page.url : ''
  let selected = currUrl.replace(/\?.*$/, '') === url
  let clz = cx('nav-item', {
    'nav-item-active': selected
  })
  return (
    <a href={url}
      class={clz}
      onClick={e => {
        e.preventDefault()
        if (selected) return
        switchTab(url)
      }}>
      <span class="nav-item-icon">{icon}</span>
      <span class="nav-item-text">{text}</span>
      <span class="nav-item-mark">{badge}</span>
    </a>
  )
})

@observer
export default class Sidebar extends Component {
  renderGroup(group) {
    return (
      <section class="nav-group" key={group.label}>
        <div class="nav-group-head">
          <strong>{group.label}</strong>
          <span>{group.hint}</span>
        </div>
        <div class="nav-items">
          {group.items.map(item => <Navigator key={item.url} {...item}/>)}
        </div>
      </section>
    )
  }
  render() {
    let {user} = store
    let groups = GROUPS.map(group => Object.assign({}, group, {
      items: group.items.filter(item => hasPermission(user, item.permission))
    })).concat(userGroup(user)).filter(group => group.items.length)
    return (
      <aside class="sidebar">
        <div class="sidebar-inner">
          <div class="sidebar-title">
            <span>VoiceMSG OS</span>
            <strong>内容、投放和权限统一处理</strong>
          </div>
          <div class="nav-groups">
            {groups.map(group => this.renderGroup(group))}
          </div>
        </div>
      </aside>
    )
  }
}
